import {
  Antena3,
  Antena3Black,
  A3series,
  A3seriesBlack,
  Bemad,
  BemadBlack,
  Boing,
  BoingBlack,
  Clan,
  ClanBlack,
  Cuatro,
  CuatroBlack,
  Discovery,
  DiscoveryBlack,
  Disney,
  DisneyBlack,
  Divinity,
  DivinityBlack,
  Dkiss,
  DkissBlack,
  Energy,
  EnergyBlack,
  FactoriaFiccion,
  FactoriaFiccionBlack,
  Forta,
  FortaBlack,
  Gol,
  GolBlack,
  LaSexta,
  LaSextaBlack,
  La1,
  La1Black,
  La2,
  La2Black,
  Mega,
  MegaBlack,
  Neox,
  NeoxBlack,
  Nova,
  NovaBlack,
  // Pago,
  // PagoBlack,
  Paramount,
  ParamountBlack,
  RealMadrid,
  RealMadridBlack,
  // Resto,
  // RestoBlack,
  Telecinco,
  TelecincoBlack,
  // Tematicas,
  // TematicasBlack,
  Ten,
  TenBlack,
  Tdp,
  TdpBlack,
  TreceTv,
  TreceTvBlack,
  Tv24h,
  Tv24hBlack
} from '../../assets/images/index';

const sharingBarsColors = [
  '#FC6410',
  '#FD7713',
  '#FE871A',
  '#FE961F',
  '#FFA726',
  '#FEB92B',
  '#FFC930',
  '#FFD14C',
  '#FFD96F',
  '#FFDF87'
];

export const sharingBarsColorsPalindrome = [
  ...sharingBarsColors,
  ...sharingBarsColors.slice(1, sharingBarsColors.length - 1).reverse()
];

export const getReducedChannelsShare = data => [
  {
    share: data.antena3,
    channel: 'Antena 3',
    colorLogo: Antena3,
    blackLogo: Antena3Black
  },
  {
    share: data.laSexta,
    channel: 'La Sexta',
    colorLogo: LaSexta,
    blackLogo: LaSextaBlack
  },
  {
    share: data.la1,
    channel: 'La 1',
    colorLogo: La1,
    blackLogo: La1Black
  },
  {
    share: data.cuatro,
    channel: 'Cuatro',
    colorLogo: Cuatro,
    blackLogo: CuatroBlack
  },
  {
    share: data.telecinco,
    channel: 'Telecinco',
    colorLogo: Telecinco,
    blackLogo: TelecincoBlack
  },
  {
    share: data.la2,
    channel: 'La 2',
    colorLogo: La2,
    blackLogo: La2Black
  },
  {
    share: data.factoriaFiccion,
    channel: 'Factoría de ficción',
    colorLogo: FactoriaFiccion,
    blackLogo: FactoriaFiccionBlack
  },
  {
    share: data.forta,
    channel: 'Forta',
    colorLogo: Forta,
    blackLogo: FortaBlack
  },
  {
    share: data.neox,
    channel: 'Neox',
    colorLogo: Neox,
    blackLogo: NeoxBlack
  },
  {
    share: data.nova,
    channel: 'Nova',
    colorLogo: Nova,
    blackLogo: NovaBlack
  }
];

export const getChannelsShare = data => {
  const reducedChannelsShare = getReducedChannelsShare(data);
  const channelsShare = [
    ...reducedChannelsShare,
    {
      share: data.a3series,
      channel: 'A3 Series',
      colorLogo: A3series,
      blackLogo: A3seriesBlack
    },
    {
      share: data.bemad,
      channel: 'Bemad',
      colorLogo: Bemad,
      blackLogo: BemadBlack
    },
    {
      share: data.boing,
      channel: 'Boing',
      colorLogo: Boing,
      blackLogo: BoingBlack
    },
    {
      share: data.clan,
      channel: 'Clan',
      colorLogo: Clan,
      blackLogo: ClanBlack
    },
    {
      share: data.discovery,
      channel: 'Discovery',
      colorLogo: Discovery,
      blackLogo: DiscoveryBlack
    },
    {
      share: data.disney,
      channel: 'Disney',
      colorLogo: Disney,
      blackLogo: DisneyBlack
    },
    {
      share: data.divinity,
      channel: 'Divinity',
      colorLogo: Divinity,
      blackLogo: DivinityBlack
    },
    {
      share: data.dkiss,
      channel: 'Dkiss',
      colorLogo: Dkiss,
      blackLogo: DkissBlack
    },
    {
      share: data.energy,
      channel: 'Energy',
      colorLogo: Energy,
      blackLogo: EnergyBlack
    },
    {
      share: data.gol,
      channel: 'Gol',
      colorLogo: Gol,
      blackLogo: GolBlack
    },
    {
      share: data.mega,
      channel: 'Mega',
      colorLogo: Mega,
      blackLogo: MegaBlack
    },
    {
      share: data.paramount,
      channel: 'Paramount',
      colorLogo: Paramount,
      blackLogo: ParamountBlack
    },
    {
      share: data.realMadrid,
      channel: 'real Madrid',
      colorLogo: RealMadrid,
      blackLogo: RealMadridBlack
    },
    {
      share: data.tdp,
      channel: 'Tdp',
      colorLogo: Tdp,
      blackLogo: TdpBlack
    },
    {
      share: data.ten,
      channel: 'Ten',
      colorLogo: Ten,
      blackLogo: TenBlack
    },
    {
      share: data.treceTv,
      channel: 'TreceTv',
      colorLogo: TreceTv,
      blackLogo: TreceTvBlack
    },
    {
      share: data.tv24h,
      channel: 'Tv24h',
      colorLogo: Tv24h,
      blackLogo: Tv24hBlack
    }
  ];

  return channelsShare;
};

export const orderByShare = data =>
  data.sort((firstItem, secondItem) =>
    firstItem.share < secondItem.share ? 1 : -1
  );
